<template>
  <div class="loading">
    <img src="@/assets/media/loaders/double-ring.gif" alt="Loading" />
  </div>
</template>

<script>
export default {
  name: 'Loading',
};
</script>

<style>
.loading {
  margin-top: 100px;
  grid-area: content;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
